export default __webpack_public_path__ + "static/media/wN.35fd2e0d.svg";